module.exports = __webpack_public_path__ + "img/unselectedLTop.f6150259.png";